// Third party libraries
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Image } from 'semantic-ui-react';

// Components
import OButton from '../../../../styled/button';

// Locales
import I18n from '../../../../../i18n';

// Models
import { GeneralOffer, PeriodicityEnum, Plan } from '../../../../../models/payment';

// Styles
import './index.scss';

// Interfaces
interface ParamsInterface {
    contractCallback?: () => void;
    periodicity: PeriodicityEnum;
    plan: Plan;
    offer?: GeneralOffer;
};

const PlanCard = ({ contractCallback = () => {}, periodicity, plan: data, offer }: ParamsInterface) => {

    const planPrice = periodicity === PeriodicityEnum.Monthly ? data.monthlyPrice : data.annualPrice;

    const discountPrice = offer ? planPrice * ( offer.discount / 100 ): 0;

    let newPlanPrice = planPrice - discountPrice;

    newPlanPrice = parseFloat(newPlanPrice.toFixed(2));

    return <div className={ `planCard ${ !offer || offer?.discount === 0 ? 'hideRibbon' : '' }` } data-ribbon={ I18n.t('landing.discount', { discount: offer?.discount }).toUpperCase() }>
        <Image src={ data.logo } />
        <span className='planTitle'>{ data.name }</span>
        <span className='manageText'>{ I18n.t('landing.manageUpToStudents', { maxStudents: data.maxStudents }) }</span>
        { newPlanPrice !== planPrice && <span className='oldPrice'>{ '$' + planPrice }</span> }
        <div className='priceBox'>
            <span className='newPrice'>{ '$' + newPlanPrice }</span><span className='periodicity'>{ '/mes' }</span>
        </div>
        <span className='forEver'>{ I18n.t(periodicity === PeriodicityEnum.Annual ? 'landing.uniqPayment' : offer?.discount !== 0 ? 'landing.forEver' : '') }</span>
        <OButton $terciary type='button' $color='#fff' className='contractButton' onClick={ contractCallback }>
            <span>{ I18n.t('landing.contract') }</span>
        </OButton>
    </div>;

};

export default PlanCard;